document.addEventListener('DOMContentLoaded', () => {
  const toggleButton = document.querySelector('.menu-two-row__mobile-toggle');
  const closeButton = document.querySelector('.menu-two-row__mobile-close');
  const overlay = document.querySelector('.menu-two-row__mobile-overlay');
  const menu = document.querySelector('.menu-two-row__mobile-nav');

  const openMobileMenu = () => {
    if (!menu || !overlay) return;
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeMobileMenu = () => {
    if (!menu || !overlay) return;
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  const toggleSubmenu = (button) => {
    const submenuId = button.getAttribute('data-submenu-id');
    const submenu = document.getElementById(submenuId);
    if (!submenu) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !isExpanded);
    submenu.classList.toggle('is-open');
  };

  if (toggleButton) {
    toggleButton.addEventListener('click', openMobileMenu);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeMobileMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMobileMenu);
  }

  document.querySelectorAll('.menu-two-row__mobile-submenu-toggle').forEach(button => {
    button.addEventListener('click', () => toggleSubmenu(button));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu && menu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  // Predictive search for two-row header
  const searchWrapper = document.querySelector('[data-two-row-search]');
  if (searchWrapper) {
    window.twoRowSearch = new TwoRowSearch(searchWrapper);
  }
});

/**
 * Predictive product search for menu-two-row header (same API and rendering as search modal).
 */
class TwoRowSearch {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.input = wrapper.querySelector('[data-two-row-search-input]');
    this.resultsContainer = wrapper.querySelector('[data-two-row-search-results]');
    this.resultsContent = wrapper.querySelector('[data-two-row-search-results-content]');
    this.loadingEl = wrapper.querySelector('[data-two-row-search-loading]');
    this.abortController = null;
    this.debounceTimer = null;
    this.blurTimer = null;
    this.currentQuery = '';
    this.moneyFormat = wrapper.dataset.twoRowSearchMoneyFormat || '{{amount}}';
    this.translations = JSON.parse(wrapper.dataset.twoRowSearchTranslations || '{}');
    this.init();
  }

  init() {
    if (!this.input || !this.resultsContent) return;
    this.setupEventListeners();
  }

  setupEventListeners() {
    const debounce = (func, wait) => {
      return (...args) => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => func.apply(this, args), wait);
      };
    };

    this.input.addEventListener('input', debounce(() => this.handleSearch(), 300));
    this.input.addEventListener('focus', () => {
      clearTimeout(this.blurTimer);
      if (this.currentQuery && this.resultsContent.innerHTML.trim()) {
        this.showResults();
      }
    });
    this.input.addEventListener('blur', () => {
      this.blurTimer = setTimeout(() => this.hideResults(), 150);
    });

    const form = this.input.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        const query = this.input.value.trim();
        if (!query) e.preventDefault();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideResults();
        this.input.blur();
      }
    });
    document.addEventListener('click', (e) => {
      if (this.resultsContainer && !this.resultsContainer.classList.contains('is-hidden') && !this.wrapper.contains(e.target)) {
        this.hideResults();
      }
    });
  }

  async handleSearch() {
    const query = this.input.value.trim();
    this.currentQuery = query;

    if (this.abortController) this.abortController.abort();
    if (!query || query.length < 2) {
      this.clearResults();
      this.hideResults();
      return;
    }

    this.showLoading();

    this.abortController = new AbortController();
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;
      const response = await fetch(url, {
        signal: this.abortController.signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Search failed');
      const data = await response.json();
      this.renderResults(data.resources.results.products || [], query);
      this.showResults();
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Two-row search error:', err);
        this.renderError();
        this.showResults();
      }
    } finally {
      this.hideLoading();
    }
  }

  renderResults(products, query = '') {
    if (!products || products.length === 0) {
      this.resultsContent.innerHTML = `
        <div class="menu-two-row__search-empty-state">
          <p class="menu-two-row__search-empty-title">${this.translations.no_products_found || 'No products found'}</p>
          <p class="menu-two-row__search-empty-text">${this.translations.try_different_keywords || 'Try different keywords'}</p>
        </div>
      `;
      return;
    }

    const convertToCents = (priceValue, originalValue) => {
      if (!priceValue || priceValue === 0) return 0;
      let price = typeof priceValue === 'string' ? parseFloat(priceValue) : Number(priceValue);
      if (price > 0 && price < 1000) {
        if (typeof originalValue === 'string' || (price === Math.floor(price) && price < 100)) {
          price = Math.round(price * 100);
        }
      }
      return price;
    };

    const resultsHTML = products.map(product => {
      const imageUrl = product.image || '';
      const hasPriceRange = product.price_min !== undefined && product.price_max !== undefined && product.price_min !== product.price_max;
      const hasCompareAtPriceRange = product.compare_at_price_min !== undefined && product.compare_at_price_max !== undefined && product.compare_at_price_min !== product.compare_at_price_max;
      let priceMin = hasPriceRange ? product.price_min : (product.price || 0);
      let priceMax = hasPriceRange ? product.price_max : (product.price || 0);
      let compareAtPriceMin = hasCompareAtPriceRange ? product.compare_at_price_min : (product.compare_at_price || 0);
      let compareAtPriceMax = hasCompareAtPriceRange ? product.compare_at_price_max : (product.compare_at_price || 0);
      priceMin = convertToCents(priceMin, hasPriceRange ? product.price_min : product.price);
      priceMax = convertToCents(priceMax, hasPriceRange ? product.price_max : product.price);
      compareAtPriceMin = convertToCents(compareAtPriceMin, hasCompareAtPriceRange ? product.compare_at_price_min : product.compare_at_price);
      compareAtPriceMax = convertToCents(compareAtPriceMax, hasCompareAtPriceRange ? product.compare_at_price_max : product.compare_at_price);
      const isOnSale = compareAtPriceMin > 0 && compareAtPriceMin > priceMin;
      let priceDisplay = hasPriceRange ? `${this.formatMoney(priceMin)} - ${this.formatMoney(priceMax)}` : this.formatMoney(priceMin);
      let comparePriceDisplay = '';
      if (isOnSale) {
        comparePriceDisplay = hasCompareAtPriceRange ? `${this.formatMoney(compareAtPriceMin)} - ${this.formatMoney(compareAtPriceMax)}` : this.formatMoney(compareAtPriceMin);
      }
      const placeholderSvg = '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path></svg>';
      return `
        <a href="${product.url}" class="menu-two-row__search-result-item">
          ${imageUrl ? `<div class="menu-two-row__search-result-image-wrapper"><img src="${imageUrl}" alt="${this.escapeHtml(product.title)}" class="menu-two-row__search-result-image" loading="lazy"></div>` : `<div class="menu-two-row__search-result-placeholder">${placeholderSvg}</div>`}
          <div class="menu-two-row__search-result-details">
            <div class="menu-two-row__search-result-title">${this.escapeHtml(product.title)}</div>
            <div class="menu-two-row__search-result-price-group">
              ${isOnSale ? `<span class="menu-two-row__search-result-price menu-two-row__search-result-price--sale">${priceDisplay}</span>${comparePriceDisplay ? `<span class="menu-two-row__search-result-compare-price">${comparePriceDisplay}</span>` : ''}` : `<span class="menu-two-row__search-result-price">${priceDisplay}</span>`}
            </div>
          </div>
        </a>
      `;
    }).join('');

    const searchQuery = query || this.currentQuery;
    const seeMore = searchQuery ? `<div class="menu-two-row__search-see-more"><a href="/search?q=${encodeURIComponent(searchQuery)}&type=product" class="menu-two-row__search-see-more-link">${this.translations.see_more || 'See more results'}</a></div>` : '';
    this.resultsContent.innerHTML = resultsHTML + seeMore;
  }

  renderError() {
    this.resultsContent.innerHTML = `
      <div class="menu-two-row__search-error-state">
        <p class="menu-two-row__search-error-title">${this.translations.something_went_wrong || 'Something went wrong'}</p>
        <p class="menu-two-row__search-error-text">${this.translations.please_try_again || 'Please try again'}</p>
      </div>
    `;
  }

  clearResults() {
    if (this.resultsContent) this.resultsContent.innerHTML = '';
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  formatMoney(cents) {
    const priceInCents = typeof cents === 'number' ? cents : parseFloat(cents) || 0;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(priceInCents, this.moneyFormat);
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceInCents / 100);
  }

  showResults() {
    if (this.resultsContainer) this.resultsContainer.classList.remove('is-hidden');
  }

  hideResults() {
    if (this.resultsContainer) this.resultsContainer.classList.add('is-hidden');
  }

  showLoading() {
    if (this.loadingEl) this.loadingEl.classList.remove('is-hidden');
    if (this.resultsContainer) this.resultsContainer.classList.add('is-hidden');
  }

  hideLoading() {
    if (this.loadingEl) this.loadingEl.classList.add('is-hidden');
  }
}
